import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://getfastestimate.com").replace(/\/$/, "");
const DEFAULT_OG = `${SITE_URL}/og-image.png`;

// Per-page SEO: title, description, canonical, Open Graph, Twitter, optional JSON-LD, optional noindex.
export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  type = "website",
  noindex = false,
  jsonLd = null,
}) {
  // Prerendered/static HTML ships its own canonical, description and JSON-LD
  // (all marked data-static-seo). Once React takes over, Helmet owns SEO tags —
  // remove ONLY the static ones so each page has exactly one of each.
  useEffect(() => {
    document.querySelectorAll("[data-static-seo]").forEach((el) => el.remove());
  }, []);
  const url = `${SITE_URL}${path}`;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet prioritizeSeoTags>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Fast Estimate" />

      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {schemas.map((s, i) => (
        <script key={s["@type"] || i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
